import http from "../http-common";

// used in BookResources.jsx
const addChapter = (bookId, chapter) => {
  return http.post(`books/${bookId}/chapters`, chapter);
};

// used in ChapterList.jsx, PageModal.jsx
const update = (chapterId, newChapterInfo) => {
  return http.put(`/chapters/${chapterId}`, newChapterInfo);
};

// used in BookPageDropDown.jsx, BookResources.jsx
const getChaptersInBook = (bookId) => {
  return http.get(`books/${bookId}/chapters`);
};

// used in BookPageDropDownV2.jsx
const getChaptersAndPagesInBook = (bookId) => {
  return http.get(`books/${bookId}/chapters/pages`);
};

// used in BookResources.jsx
const deleteChapter = (bookId, chapterId) => {
  console.log("DELETING CHAPTER....");
  return http.delete(`/books/${bookId}/chapters/${chapterId}`);
};

// used in BookResources.jsx
const uploadChapters = (data) => {
  return http.post(`/chapters/`, data);
};

// used in BookPageDropDown.jsx, PageModal.jsx; commented out in ChapterList.jsx
const getPagesInChapter = (bookId, chapterId) => {
  return http.get(`/books/${bookId}/chapters/${chapterId}/pages`);
};

// used in PageModal.jsx, PageModalV2.jsx
const uploadPageData = (chapterId, pageData) => {
  return http.post(`/chapters/${chapterId}/pages`, pageData);
};

// used in PageModal.jsx, PageModalV2.jsx
const uploadPageContent = (pageId, content) => {
  return http
    .post(`pages/${pageId}/content`, content)
    .then(() => {
      console.log("page image uploaded: ", pageId);
    })
    .catch((e) => console.log("erro upload page image: ", e));
};

// const uploadVideoLink = (chapterId, pageTitleDto) => {
//   return http.post(`chapters/${chapterId}/videoLink`, pageTitleDto);
// };

// used in DevelopTool.jsx
const uploadPageJSON = (pageId, file) => {
  return http.post(`pages/${pageId}/json`, file);
};

// used in ChapterList.jsx
const updateChapters = (chapters) => {
  return http.put(`chapters/update`, chapters);
};

// used in PageModalV2.jsx
const getChapterPages = (chapterId) => {
  return http.get(`chapters/${chapterId}/page/details`);
};

// used in PageModalV2.jsx
const uploadChapterDetails = (chapterId, details) => {
  return http.put(`chapters/${chapterId}/details`, details);
};

// used in BookpageDropDownV2.jsx
const getPageJson = (bookId, page) => {
  return http.get(
    `https://d24hdgytax3x03.cloudfront.net/${bookId}/pages/${page.jsonLink}`
  );
};
const getPageJSONFromDPIApi = async (pageId) => {
  try {
    const response = await http.get(`/pages/${pageId}/json`);
    const responseText = response.data;
    console.log("Response text:", responseText);

    if (!responseText) {
      throw new Error("Empty response from server");
    }

    // const data = JSON.parse(responseText);
    return responseText;
  } catch (error) {
    console.log("Fetch error:", error);
    throw error;
  }
};
// used in PageModalV2.jsx
const uploadAudioFile = (chapterId, audioFile) => {
  return http.post(`chapters/${chapterId}/audio`, audioFile);
};

// used in PageModalV2.jsx
const postVideoPoster = (chapterId, file) => {
  return http.post(`chapters/${chapterId}/poster/`, file);
};

const uploadBookData = (bookId) => {
  return http.post(`file/${bookId}`);
};

const uploadChapterThumbnail = (chapterId, file) => {
  return http.post(`chapters/${chapterId}/thumbnail`, file);
};

const uploadPageThumbnail = (chapterId, pageIndex, file) => {
  return http
    .post(`chapters/${chapterId}/thumbnail/${pageIndex}`, file)
    .then((res) => res.data);
};

const ChapterDataService = {
  addChapter,
  update,
  getChaptersInBook,
  deleteChapter,
  uploadChapters,
  getPagesInChapter,
  uploadPageContent,
  uploadPageData,
  // uploadVideoLink,
  uploadPageJSON,
  updateChapters,
  getChapterPages,
  uploadChapterDetails,
  getChaptersAndPagesInBook,
  getPageJson,
  uploadAudioFile,
  postVideoPoster,
  uploadBookData,
  uploadChapterThumbnail,
  uploadPageThumbnail,
  getPageJSONFromDPIApi,
};

export default ChapterDataService;
